import {Vue, Component, Prop, PropSync, Provide, ProvideReactive, Watch} from 'vue-property-decorator';
import IndieInput from "@/app/shared/components/indie-input.vue";
import { Inject } from "inversify-props";
import { BookingService } from "../../services/booking.service";
import { debounceTime, pluck, switchMap } from "rxjs/operators";
import { from } from "rxjs";
import Itinerary from "../../shared/models/itinerary.model";
import { State } from "../../shared/models/state.model";
import { Country } from "../../shared/models/country.model";
import BillingForm from "../../shared/models/billing-form.model";
import VModal from "vue-js-modal";
import Helpers from "@/app/shared/common/helpers";
import {CreditService} from "@/app/services/credit.service";

Vue.use(VModal);

@Component<PaymentComponent>({
  components: ({
    IndieInput
  }),
  subscriptions() {
    return {
      country: this.$fromDOMEvent(".country", "keyup").pipe(
        debounceTime(300),
        pluck<Event, string>("target", "value"),
        switchMap(value => from(this.searchCountry(value)))
      ),
      state: this.$fromDOMEvent(".state", "keyup").pipe(
        debounceTime(300),
        pluck<Event, string>("target", "value"),
        switchMap(value => from(this.searchState(value, this.billingForm.country)))
      ),
      city: this.$fromDOMEvent(".city", "keyup").pipe(
        debounceTime(300),
        pluck<Event, string>("target", "value"),
        switchMap(value => from(this.searchCity(value, this.billingForm.state)))
      )
    };
  }
})
export default class PaymentComponent extends Vue {
  @Inject() private readonly bookingService: BookingService;
  @Inject() private readonly creditService: CreditService;

  @Prop() private propsPersons: any;
  @Prop() private propsIsValidForm: number;
  @Prop() private propsBillingForm: BillingForm;
  @Prop() private propsCurrency: any;
  @Prop() private propsTotalCost: number;
  @Prop() private propsSelectDate: Function;
  @Prop() private propsChangeBilling: Function;
  @Prop() private propsCityList: any;
  @Prop() private propsSearchInProcess: any;
  @Prop() private propsOnCityChange: Function;
  @Prop() private propsStateList: any;
  @Prop() private propsCountryList: any;
  @Prop() private propsPaymentModel: any;
  @Prop() private propsCardYearsList: any;
  @Prop() private propsCardNumberValidate: Function;
  @Prop() private propsCvvValidate: Function;
  @Prop() private propsPurchaseCheck: boolean;
  @Prop() private propsCheckPurchase: Function;

  public persons: any = this.propsPersons;
  public isValidForm: any = this.propsIsValidForm;
  public billingForm = this.propsBillingForm;
  public currency = this.propsCurrency;
  public totalCost = this.propsTotalCost;
  public cityList = this.propsCityList;
  public searchInProcess = this.propsSearchInProcess;
  public stateList = this.propsStateList;
  public countryList = this.propsCountryList;
  public paymentModel = this.propsPaymentModel;
  public cardYearsList = this.propsCardYearsList;
  public selectDate = this.propsSelectDate;
  public changeBilling = this.propsChangeBilling;
  public onCityChange = this.propsOnCityChange;
  public cardNumberValidate = this.propsCardNumberValidate;
  public cvvValidate = this.propsCvvValidate;
  public isLoading: boolean = false;

  constructor() {
    super();
  }

  mounted() {
    return true;
  }

  created() {
    return true;
  }

  destroyed() {
    return true;
  }

  updated() {
    return true;
  }

  public get usedAirlineCredit(){
    return this.creditService.getUsedAirlineCredit(this.$store);
  }


  private async submit() {
    this.isLoading = true;
    const validCardExpiration =
      this.paymentModel.pay_type !== "card" || (this.paymentModel.expire_month > 0 && this.paymentModel.expire_year > 0);

    await this.$validator.validate().then(valid => {
      this.isValidForm = (valid && validCardExpiration) || this.usedAirlineCredit;
    });

    if(this.isValidForm){
      // @ts-ignore
      await this.$parent.submitBooking().then((res: any) => {
        this.isLoading = false;
      }).catch((err: any) => {
        this.isLoading = false;
      })
    } else {
      this.isLoading = false;
    }
    return this.isValidForm;
  }

  public searchState(value: string, parent: string) {
    this.stateList = [];
    this.searchInProcess = true;
    return this.bookingService
      .getStateList({
        parent: parent,
        query: value
      })
      .then(res => {
        this.stateList = res.data.response;
        if(1 === this.stateList.length){
          this.billingForm.state = this.stateList[0].value;
        }
        this.searchInProcess = false;
        this.stateList.sort((a: State, b: State) =>
          a.value > b.value ? 1 : b.value > a.value ? -1 : 0
        );
      });
  }

  public searchCountry(value: string) {
    this.countryList = [];
    this.searchInProcess = true;
    return this.bookingService
      .getCountryList({
        parent: "",
        query: value
      })
      .then(res => {
        this.countryList = res.data.response;
        if(1 === this.countryList.length){
          this.billingForm.country = this.countryList[0].value;
        }
        this.searchInProcess = false;
        this.countryList.sort((a: Country, b: Country) =>
          a.value > b.value ? 1 : b.value > a.value ? -1 : 0
        );
      });
  }

  public searchCity(value: string, parent: string) {
    this.cityList = [];
    this.searchInProcess = true;
    return this.bookingService
      .getCityList({
        parent: parent,
        query: value
      })
      .then(res => {
        this.cityList = res.data.response;
        if(1 === this.cityList.length){
          this.billingForm.city = this.cityList[0].value;
        }
        this.searchInProcess = false;
        this.cityList.sort((a: Itinerary, b: Itinerary) =>
          a.city > b.city ? 1 : b.city > a.city ? -1 : 0
        );
      });
  }
}
